import { connect } from 'react-redux';

import { MainMenu } from '../components/MainMenu';
import { StoreState } from '../store/store';
import { appActions } from '../actions/appAction';
import { viewerActions } from '../actions/viewerAction';

export interface MainMenuActions {
    initExaminationViewerAsync: (actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => void;
    setPosNextPrev: (pos: number) => void;
    setLoading: (loading: boolean) => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        initExaminationViewerAsync: (actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => dispatch(
            appActions.initExaminationViewerAsync(actId, editingId, stepId, examinationtype, miekesi)),
        setPosNextPrev: (pos: number) => dispatch(viewerActions.setPosNextPrev(pos)),
        setLoading: (loading: boolean) => dispatch(appActions.setLoading(loading)),
    }
}

const mapStateToProps = (state: StoreState) => {
    return Object.assign({}, state.viewerState, state.appState);
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
